import * as amplitude from "@amplitude/analytics-browser"
import { Acc2Gradient } from "component_old/micro/design/Acc2Gradient"
import { ModalWrapper } from "component_old/modal/ModalWrapper"
import { CtxModal, ModalStateProvider } from "component_old/modal/ctxModal"
import { useI18next } from "gatsby-plugin-react-i18next"
import coreConfig from "libs/config/coreConfig"
import { Localization } from "libs/localization/localization"
import { useAnalytics } from "libs/utils/external/analytics"
import { isSsr } from "libs/utils/logic/isServer"
import React, { useContext, useEffect } from "react"

if (!isSsr()) {
  amplitude.init(coreConfig.AmplitudeApiKey)
}

interface Props {
  children: React.ReactNode
}

const PageWrapperInner = (props: Props): JSX.Element => {
  const ctxModal = useContext(CtxModal)
  const analytics = useAnalytics()
  const { language } = useI18next()

  Localization.setLanguage(language)

  useEffect(() => {
    // Initial analytics page view report
    analytics.track("page.view")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeof window !== "undefined" ? window.location?.pathname : false])

  return (
    <div id="mapheim">
      {ctxModal.modal && <ModalWrapper />}
      {props.children}
    </div>
  )
}

export const PageWrapper = (props: Props): JSX.Element => {
  return (
    <>
      <Acc2Gradient />
      <ModalStateProvider>
        <PageWrapperInner>{props.children}</PageWrapperInner>
        <script
          type="text/javascript"
          id="hs-script-loader"
          async
          defer
          src="//js-eu1.hs-scripts.com/27147314.js"
        />
      </ModalStateProvider>
    </>
  )
}
